import React, { useState } from 'react';
import { Mail, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useLanguage } from '../context/LanguageContext';
import { newsletterContent } from '../data/mock';
import { toast } from '../hooks/use-toast';

const Newsletter = () => {
  const { language } = useLanguage();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast({
        title: language === 'en' ? 'Error' : 'Error',
        description: language === 'en' ? 'Please enter your email' : 'Por favor ingresa tu email',
        variant: 'destructive'
      });
      return;
    }

    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      toast({
        title: language === 'en' ? 'Success!' : '¡Éxito!',
        description: language === 'en' 
          ? 'You\'ve been added to our newsletter!' 
          : '¡Has sido añadido a nuestro boletín!',
      });
      setEmail('');
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <div className="fixed left-0 top-1/2 -translate-y-1/2 z-40 hidden xl:block">
      <div className="bg-gradient-to-br from-gray-800/95 to-gray-900/95 backdrop-blur-xl rounded-r-3xl shadow-2xl border-r border-t border-b border-gray-700/50 p-8 w-80 transform -translate-x-64 hover:translate-x-0 transition-transform duration-500 group">
        {/* Tab */}
        <div className="absolute -right-12 top-1/2 -translate-y-1/2 bg-emerald-500 hover:bg-emerald-600 text-white px-3 py-6 rounded-r-xl cursor-pointer transition-colors shadow-lg">
          <Mail className="w-6 h-6" />
        </div>

        {/* Content */}
        <div className="space-y-6">
          <div className="space-y-2">
            <h3 className="text-2xl font-bold text-white">
              {language === 'en' ? newsletterContent.title_en : newsletterContent.title_es}
            </h3>
            <p className="text-gray-400 text-sm">
              {language === 'en' ? newsletterContent.subtitle_en : newsletterContent.subtitle_es}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              type="email"
              placeholder={language === 'en' ? newsletterContent.placeholder_en : newsletterContent.placeholder_es}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-gray-700/50 border-gray-600 text-white placeholder:text-gray-500 focus:border-emerald-500"
            />
            <Button
              type="submit"
              className="w-full bg-emerald-500 hover:bg-emerald-600 text-white font-semibold"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span>{language === 'en' ? 'Joining...' : 'Uniéndose...'}</span>
              ) : (
                <>
                  {language === 'en' ? newsletterContent.button_en : newsletterContent.button_es}
                  <ArrowRight className="ml-2 w-4 h-4" />
                </>
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;